
import { HiMiniArrowLongRight } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { commonToast } from "../helper/Toast";
import { useTranslation } from "react-i18next";
import { ApiPost } from "../helper/axiosFunctions";
import LanguageDropdown from "../components/LanguageDropdown";
import UserAvatar from "../components/UserAvatar";

export default function ProfilePag() {
  const { t } = useTranslation();
  const userData = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data;
  console.log("userData", userData);

  const handleLogut = async () => {
    const body = {
      refreshToken: userData?.tokens?.refreshToken,
    };
    try {
      await ApiPost("/auth/logout", body);
      commonToast(t("logoutmsg"), "success");
      localStorage.removeItem("zubrus_user_data");
      localStorage.removeItem("persist:root");
      localStorage.removeItem("overview_helper_hidden");
      localStorage.removeItem("material_helper_hidden");
      localStorage.removeItem("people_helper_hidden");
      localStorage.removeItem("creator_helper_hidden");
      window.location.reload();
    } catch (error) {
      commonToast(error?.data?.error || error?.message, "error");
    }
  };

  const profilePictureUrl = userData?.userInfo?.profilePictureUrl;

  return (
    <div className="max-w-7xl mx-auto text-center p-10 md:p-5">
      <UserAvatar
        src={profilePictureUrl}
        firstName={userData?.userInfo?.firstName}
        lastName={userData?.userInfo?.lastName}
        username={userData?.userInfo?.username}
        email={userData?.userInfo?.email}
        size="md"
        className="mx-auto mb-4"
      />
      <h1 className="text-2xl font-semibold ">
        {userData?.userInfo?.firstName && userData?.userInfo?.lastName
          ? `${userData.userInfo.firstName} ${userData.userInfo.lastName}`
          : userData?.userInfo?.username}
      </h1>
      <h6 className="base-text  text-lightgray">{t("profile")}</h6>

      <div className="bg-bluelight flex md:flex-col justify-between gap-5 items-center p-7 rounded-3xl  mx-auto my-5 max-w-md">
        <div className="text-start">
          <h2 className="medium-text">{t("creator")}</h2>
          <h3 className="regular-text">{t("creatordes")}</h3>
        </div>
        <Link to="/creator">
          <button className="primary-btn px-5">{t("want")}</button>
        </Link>
      </div>

      <div className="max-w-md mx-auto  divide-y divide">
        <Link
          to="/user-info"
          className="flex group items-center justify-between py-3 cursor-pointer"
        >
          <h2 className="regular-text group-hover:text-darkblue">{t("Personaldata")}</h2>
          <HiMiniArrowLongRight className="group-hover:text-darkblue" />
        </Link>
        <Link
          to="/user-email"
          className="flex group items-center justify-between py-3 cursor-pointer"
        >
          <h2 className="regular-text group-hover:text-darkblue">{t("email")}</h2>
          <HiMiniArrowLongRight className="group-hover:text-darkblue" />
        </Link>
        <Link
          to="/change-password"
          className="flex group items-center justify-between py-3 cursor-pointer"
        >
          <h2 className="regular-text group-hover:text-darkblue">{t("changepassword")}</h2>
          <HiMiniArrowLongRight className="group-hover:text-darkblue" />
        </Link>
        <div className="flex group items-center justify-between py-3 cursor-pointer">
          <h2 className="regular-text group-hover:text-darkblue">{t("changelan")}</h2>
          <LanguageDropdown className="group-hover:text-darkblue" />
        </div>
        <div onClick={() => handleLogut()} className="flex group items-center justify-between py-3 cursor-pointer">
          <div className="regular-text group-hover:text-darkblue">
            {t("logout")}
          </div>
        </div>
      </div>
    </div>
  );
}
